import { Sentiment } from "@edgetier/watchtower-types";

/**
 * Date format string for message timestamps in the chat.
 * Format: "h:mm:ssaaa" (e.g., "1:30:45pm")
 */
export const MESSAGE_TIME_FORMAT = "h:mm:ssaaa";

/**
 * Date format string for the day badge above each day's messages in the chat.
 * Format: "cccc, do LLLL yyyy" (e.g., "Monday, 3rd March 2025")
 */
export const MESSAGE_DAY_FORMAT = "cccc, do LLLL yyyy";

/** The author shown above a bot's message when the bot has no agent name. */
export const AUTOMATED_AUTHOR_NAME = "Automated";

/** The sentiments a customer's message can show, in the order they are shown. */
export const CUSTOMER_SENTIMENTS = [Sentiment.Frustration, Sentiment.Confusion, Sentiment.Gratitude, Sentiment.Praise];
